module.exports = __webpack_public_path__ + "static/media/music-play.ede70b48.svg";